import React, { Component } from "react";
import { Helmet } from "react-helmet";
import FaqData from "assets/data/faq.json";

import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { GlamboxLocalStore } from "core/glambox/GlamboxLocalStore";
import { showPortalGp } from "core/utils/SubscriberUtils";

class Faq extends Component {

  constructor(props) {
    super(props);
  }

  renderFaqData = () => {

    let { state } = this.props;
    let gpActive = showPortalGp();

    if(!gpActive) {
      return FaqData.map((item, key) => {
        return (
          <div key={key} className={"faq_glampartners pb-4"}>
            <h2>{item.name}</h2>
  
            <div className={"level-2 p-3 p-xl-5 category"}>
              {(() => {
                return item.questions.map((question, qKey) => {
                  return (
                    <div key={qKey} className={"pb-4"}>
                      <h4>{question.title}</h4>
                      <p dangerouslySetInnerHTML={{ __html: question.text }} />
                    </div>
                  );
                });
              })()}
            </div>
          </div>
        );
      });
    }
  }


  openWhatsapp() {

    let localStore = new GlamboxLocalStore();
    let hostname = window.location.hostname;

    let dataLayerEvent = {
      utm_campaign: localStore.get("utm_campaign"),
      utm_source: localStore.get("utm_source"),
      utm_medium: localStore.get("utm_medium"),
      utm_content: localStore.get("utm_content")
    };

    let text = "Alguma Dúvida?"
    let url = String('https://api.whatsapp.com/send?text=' + encodeURIComponent(text));

    if (!/(b4a\.net\.br|localhost)/g.test(hostname)) {
      window.dataLayer.push(Object.assign(
        {},
        dataLayerEvent,
        {
          event: "convidar_whatsapp"
        }
      ));
    }

    if (url) {
      window.open(url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
    }
  }


  render() {
    return (
      <div className={"p-2 p-lg-5"}>
        <Helmet>
          <title>Minha Glambox : FAQ</title>
        </Helmet>
        {this.renderFaqData()}
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  state: state.state

});

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

Faq = connect(
  mapStateToProps,
  mapDispatchToProps
)(Faq);

export { Faq }; 